import { Provider } from './provider.model';
import { BookingAttendee } from './booking-attendee.model';
import { BookingSelectionItem } from './booking-selection-item.model';
import { BookingProduct } from './booking-product.model';
import { Interval } from './interval.model';
import { Price } from "./cart/price.model";
import { User } from "./user.model";
import { Real } from "./real.model";
import { Service } from "./service.model";
import { Event } from "./event.model";
import { environment } from '../../../environments/environment';

import * as moment from 'moment';
import 'moment-timezone';
moment.tz.setDefault("Europe/Ljubljana");

export enum BookingStatus {
  Reserved = "reserved", 
  Canceled = "canceled", 
  NoShow = "no-show", 
  Arrived = "arrived", 
  Departed = "departed" 
}

//Mode 20 Booking Model
export class Booking {
  
  /* Api data */
  public id: string;
  public mode: number = 20; //For now only table booking
  public start: string;
  public created: string;
  public updated: string;
  
  public oldStart: string;

  /*picked data*/
  public selectedEnd: string;
  public selectedDurationInSeconds: number;

  public provider: Provider;
  public canceled: boolean;
  public canceledDt: string;
  public canceledByAdmin: boolean;
  public bookingSelectionItems: BookingSelectionItem[] = [];
  public bookingProducts: BookingProduct[] = [];
  public bookingAttendees: BookingAttendee[] = [];
  public customerNotes: string;
  public editorNotes: string;
  public receiptNotes: string;
  public emailNotes: string;
  public partySize: number;
  public enteredByAdmin: boolean;

  /* Events*/

  public registrationStatus: number = 10;

  public paymentAmount: number;

  public regularPaymentAmount: number;
  public discountPercentage: number;
  public discountAmount: number;

  public preferredPaymentMethodByCustomer: number;

  public paymentByBankTransfer: boolean;
  public amountPaidByBankTransfer: number;

  public paymentAtTheCounter: boolean;
  public amountPaidAtTheCounter: number;

  public paymentOnSite: boolean;
  public amountPaidOnSite: number;

  public paymentByVoucher: boolean;
  public voucherCode: string;
  public voucherCode2: string;
  public voucherCode3: string;
  public voucherCode4: string;
  public voucherCode5: string;
  public voucherCode6: string;
  public otherVoucherCodes: string;
  public amountPaidByVoucher: number;


  public paymentAmountByVoucher: number;
  public paymentAmountByCard: number;

  public paymentByCard: boolean;
  public amountPaidByCard: number;

  //add payments - array of payment objects for online payments
  /* End of Events */ 

  public arrived: string;
  public departed: string;
  public noShow: boolean;
  public noShowDt: string;
  
  public user: User;
  public noUserSelected: boolean = true;
  public _self: string;

  /* Derived data */
  public end: string;
  public total: Price;
  public durationInSeconds: number;
  public resourceIds: string[] = [];
  public status: number;
  public color: string;

  /* Events*/
  public amountToBePaid: number;


  public paid: string;
  public isPaid: boolean;
  public paymentRequired: boolean;

  public noShowProtection: boolean;
  public noShowProtected: string;
  public noShowMaxPenalty: number;
  public noShowPenaltyAmountCharged: number;
  public noShowPenaltyCharged: string;
  public noShowWithoutPenalty: string;
  public noShowPenaltyChargingFailed: string;
  public noShowPenaltyChargingFailedReason: string;

  public fjcEventId: string;
  public fjcEventType: string;
  public fjcEventName: string;
  public fjcEventReference: string;
  public fjcContactPersonAtLocation: string;
  public fjcContactPersonPhone: string;
  public fjcContactPersonEmail: string;
  public fjcContactPersonCellPhone: string;

  public fjcInfoHtml: string;
  public fjcPartySizeNotes: string;
  public fjcExpectedPartySize: number;

  public onBehalfOfName: string;
  public onBehalfOfEmail: string;
  public onBehalfOfPhone: string;
  public onBehalfOfReminders: boolean;

  public event: Service;
  public occasion: Event;

  public statusStr: string;

  public newFromToday: boolean;


  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id || null;

    this.mode = obj && obj.mode || 20;
    
    //this.start = obj && obj.start || null;


    //this.end = obj && obj.end || null;
    this.selectedEnd = obj && obj.selectedEnd || null;
    this.selectedDurationInSeconds = obj && obj.selectedDurationInSeconds || null;

    if ( obj && obj.end ) {
      //convert timezone format - api +200 vs ionic +2:00
      this.end = moment( obj.end ).format();
    }


    if ( obj && obj.start ) {
      //convert timezone format - api +200 vs ionic +2:00
      this.start = moment( obj.start ).format();
    }

    this.created = obj && obj.created || null;
    this.updated = obj && obj.updated || null;
    this.canceled = obj && obj.canceled || null;
    this.canceledDt = obj && obj.canceledDt || null;
    this.canceledByAdmin = obj && obj.canceledByAdmin || null;
    this.customerNotes = obj && obj.customerNotes || null;
    this.editorNotes = obj && obj.editorNotes || null;
    this.receiptNotes = obj && obj.receiptNotes || null;
    this.emailNotes = obj && obj.emailNotes || null;
    this.partySize = obj && obj.partySize || null;
    this.enteredByAdmin = obj && obj.enteredByAdmin || null;
    this.noUserSelected = obj && obj.noUserSelected || null;

    this.registrationStatus = obj && obj.registrationStatus || null;
    this.paymentAmount = obj && obj.paymentAmount || null;
    this.regularPaymentAmount = obj && obj.regularPaymentAmount || null;
    this.discountPercentage = obj && obj.discountPercentage || null;
    this.discountAmount = obj && obj.discountAmount || null;

    this.preferredPaymentMethodByCustomer = obj && obj.preferredPaymentMethodByCustomer || null;
    this.paymentByBankTransfer = obj && obj.paymentByBankTransfer || null;
    this.amountPaidByBankTransfer = obj && obj.amountPaidByBankTransfer || null;
    this.paymentAtTheCounter = obj && obj.paymentAtTheCounter || null;
    this.amountPaidAtTheCounter = obj && obj.amountPaidAtTheCounter || null;
    this.paymentOnSite = obj && obj.paymentOnSite || null;
    this.amountPaidOnSite = obj && obj.amountPaidOnSite || null;
    this.paymentByVoucher = obj && obj.paymentByVoucher || null;
    this.voucherCode = obj && obj.voucherCode || null;
    this.voucherCode2 = obj && obj.voucherCode2 || null;
    this.voucherCode3 = obj && obj.voucherCode3 || null;
    this.voucherCode4 = obj && obj.voucherCode4 || null;
    this.voucherCode5 = obj && obj.voucherCode5 || null;
    this.voucherCode6 = obj && obj.voucherCode6 || null;
    this.otherVoucherCodes = obj && obj.otherVoucherCodes || null;
    
    this.amountPaidByVoucher = obj && obj.amountPaidByVoucher || null;
    
    this.paymentByCard = obj && obj.paymentByCard || null;
    this.amountPaidByCard = obj && obj.amountPaidByCard || null;

    this.fjcEventId = obj && obj.fjcEventId || null;
    this.fjcEventType = obj && obj.fjcEventType || null;
    this.fjcEventName = obj && obj.fjcEventName || null;
    this.fjcEventReference = obj && obj.fjcEventReference || null;
    this.fjcContactPersonAtLocation = obj && obj.fjcContactPersonAtLocation || null;
    this.fjcContactPersonPhone = obj && obj.fjcContactPersonPhone || null;
    this.fjcContactPersonEmail = obj && obj.fjcContactPersonEmail || null;
    this.fjcContactPersonCellPhone = obj && obj.fjcContactPersonCellPhone || null;
    this.fjcInfoHtml = obj && obj.fjcInfoHtml || null;
    this.fjcPartySizeNotes = obj && obj.fjcPartySizeNotes || null;
    this.fjcExpectedPartySize = obj && obj.fjcExpectedPartySize || null;

    this.arrived = obj && obj.arrived || null;
    this.departed = obj && obj.departed || null;
    this.noShow = obj && obj.noShow || null;
    this.noShowDt = obj && obj.noShowDt || null;

    this.paid = obj && obj.paid || null;
    this.isPaid = obj && obj.isPaid || null;
    this.paymentRequired = obj && obj.paymentRequired || null;

    this.noShowProtection = obj && obj.noShowProtection || null;
    this.noShowProtected = obj && obj.noShowProtected || null;
    this.noShowMaxPenalty = obj && obj.noShowMaxPenalty || null;
    this.noShowPenaltyAmountCharged = obj && obj.noShowPenaltyAmountCharged || null;

    this.noShowPenaltyCharged = obj && obj.noShowPenaltyCharged || null;
    this.noShowWithoutPenalty = obj && obj.noShowWithoutPenalty || null;
    this.noShowPenaltyChargingFailed = obj && obj.noShowPenaltyChargingFailed || null;
    this.noShowPenaltyChargingFailedReason = obj && obj.noShowPenaltyChargingFailedReason || null;

    this.onBehalfOfName = obj && obj.onBehalfOfName || null;
    this.onBehalfOfPhone = obj && obj.onBehalfOfPhone || null;
    this.onBehalfOfEmail = obj && obj.onBehalfOfEmail || null;
    this.onBehalfOfReminders = obj && obj.onBehalfOfReminders || null;

    this.status = obj && obj.status || null;
    
    if ( obj && obj.provider ) {
      this.provider = ( obj.provider instanceof Provider ) ? obj.provider : new Provider( obj.provider );
    }

    if ( obj && obj.event ) {
      this.event = ( obj.event instanceof Service ) ? obj.event : new Service( obj.event );
    }

    if ( obj && obj.occasion) {
      this.occasion = ( obj.occasion instanceof Event ) ? obj.occasion : new Event( obj.occasion );
    }

    if ( obj && obj.user ) {
      this.user = ( obj.user instanceof User ) ? obj.user : new User( obj.user );
    }

    if ( obj && obj.bookingSelectionItems   ) {
       
       console.log(obj.bookingSelectionItems );
       
       this.bookingSelectionItems = [];
       
       for (let bsi of obj.bookingSelectionItems ) {

         if ( bsi instanceof BookingSelectionItem ) {
           this.bookingSelectionItems.push( bsi );
         } else {
           this.bookingSelectionItems.push( new BookingSelectionItem( bsi ) );
         }

       }
    }

    if ( obj && obj.bookingProducts   ) {
       
       this.bookingProducts = [];
       
       for (let bp of obj.bookingProducts ) {

         if ( bp instanceof BookingProduct ) {
           this.bookingProducts.push( bp );
         } else {
           this.bookingProducts.push( new BookingProduct( bp ) );
         }

       }
    }

    if ( obj && obj.bookingAttendees ) {
       
       console.log(obj.bookingAttendees );
       
       this.bookingAttendees = [];
       
       for (let ba of obj.bookingAttendees ) {

         if ( ba instanceof BookingAttendee ) {
           this.bookingAttendees.push( ba );
         } else {
           this.bookingAttendees.push( new BookingAttendee( ba ) );
         }

       }
    }

    if ( obj && obj._self ) {
      this._self = obj._self;

    } else if ( obj && obj._links && obj._links.self && obj._links.self.href ) {
      this._self = obj._links.self.href;
    }

    this.refreshDerivedData();

  }


  getShopName() {

    if ( this.occasion && this.occasion.name ) {
      return this.occasion.name;
    }

    return '';
  }

  getShopImage() {

    if ( this.occasion && this.occasion.activity && this.occasion.activity.avatarHref ) {
      return this.occasion.activity.avatarHref;
    }

    return '';
  }

  addBookingAttendee(bookingAttendee: BookingAttendee) {
    this.bookingAttendees = [...this.bookingAttendees, bookingAttendee];

    if (this.partySize < this.bookingAttendees.length ) {
      this.partySize = this.bookingAttendees.length;

      this.refreshDerivedData();
    }

  }

  editBookingAttendee(updatedAttendee: BookingAttendee) {
    this.bookingAttendees = this.bookingAttendees.map(attendee =>
      attendee.id === updatedAttendee.id 
        ? new BookingAttendee({ ...attendee, ...updatedAttendee })  // ✅ Ensure correct instance
        : attendee
    );
  }


  // Remove attendee immutably
  removeBookingAttendee( bookingAttendeeId: string ) {
    this.bookingAttendees = this.bookingAttendees.filter(attendee => attendee.id !== bookingAttendeeId);

    if ( this.partySize > this.bookingAttendees.length ) {
      this.partySize = this.bookingAttendees.length;
      this.refreshDerivedData();
    }
    
  }

  removeBookingAttendeeByIndex(index: number) {
    if (index < 0 || index >= this.bookingAttendees.length) {
      console.warn('Invalid index for attendee removal:', index);
      return;
    }

    this.bookingAttendees = this.bookingAttendees.filter((_, i) => i !== index);

    if ( this.partySize > this.bookingAttendees.length ) {
      this.partySize = this.bookingAttendees.length;
      this.refreshDerivedData();
    }

  }

  getStartTime() {
    return moment(this.start).format('H:mm');
  }

   /*   this.paymentAmount = obj && obj.paymentAmount || null;
    this.preferredPaymentMethodByCustomer = obj && obj.preferredPaymentMethodByCustomer || null;
    this.paymentByBankTransfer = obj && obj.paymentByBankTransfer || null;
    this.amountPaidByBankTransfer = obj && obj.amountPaidByBankTransfer || null;
    this.paymentAtTheCounter = obj && obj.paymentAtTheCounter || null;
    this.amountPaidAtTheCounter = obj && obj.amountPaidAtTheCounter || null;
    this.paymentOnSite = obj && obj.paymentOnSite || null;
    this.amountPaidOnSite = obj && obj.amountPaidOnSite || null;
    this.paymentByVoucher = obj && obj.paymentByVoucher || null;
    this.amountPaidByVoucher = obj && obj.amountPaidByVoucher || null;
*/


  public calculateAmountToBePaid() {

    if (!this.paymentAmount) {


      this.amountToBePaid = 0.00;
      return this.amountToBePaid;
    }

    let amountToBePaid = this.paymentAmount;

    if ( this.paymentByBankTransfer && this.amountPaidByBankTransfer ) {
      amountToBePaid -= this.amountPaidByBankTransfer;
    }

    if ( this.paymentAtTheCounter && this.amountPaidAtTheCounter) {
      amountToBePaid -= this.amountPaidAtTheCounter;
    }

    if ( this.paymentOnSite && this.amountPaidOnSite) {
      amountToBePaid -= this.amountPaidOnSite;
    }

    if ( this.paymentByVoucher && this.amountPaidByVoucher) {

      amountToBePaid -= this.amountPaidByVoucher;
    }

    this.amountToBePaid = amountToBePaid;
    return this.amountToBePaid;

  }

  //Readonly methods useful for 
  public getTotalAmountPaid(): number {
    let total = 0;

    const amounts = [
      this.amountPaidByBankTransfer,
      this.amountPaidAtTheCounter,
      this.amountPaidOnSite,
      this.amountPaidByVoucher,
      this.amountPaidByCard
    ];

    for (const amount of amounts) {
      const parsed = parseFloat(amount as any);
      if (!isNaN(parsed)) {
        total += parsed;
      }
    }

    return total;
  }

  public isFullyPaid(): boolean {
    return this.getTotalAmountPaid() >= this.paymentAmount;
  }

  public getRemainingToBePaid(): number {
    return Math.max(0, (this.paymentAmount || 0) - this.getTotalAmountPaid());
  }


  /*getPickedTablesMaxCapacity() {

    let maxCapacity = 0;

    for ( let bsi of this.bookingSelectionItems ) {
      maxCapacity += bsi.selectionItem.real.capacityMax;
    }

    return maxCapacity;

  }*/

  setPartySize( newPartySize ) {
    this.partySize = newPartySize;
  }

  getInterval() {
    return new Interval( this.start, this.end );
  }

  /*move( oldReal: Real, newReal: Real, newStart ) {

    this.oldStart = this.start;

    if ( !oldReal || !newReal || ( oldReal.id === newReal.id )  ) {

      if ( newStart === this.start ) {
        return false;
      }

      let newInterval = this.getInterval()
      newInterval.moveToNewFrom( newStart );

      this.setInterval( newInterval );


    } else {

      
      for ( let bsi of this.bookingSelectionItems ) {

        if ( bsi.selectionItem.real.id !== oldReal.id ) {
          continue;
        }


        if ( newStart !== this.start ) {
          bsi.setStart( newStart, true );
        }
        

        bsi.selectionItem = newReal.getSelectionItem();

      }

    }

    if ( newStart !== this.start ) {
      this.start = newStart;
    }
    
    this.refreshDerivedData();
    return true;


  }*/


  setInterval( interval: Interval, sameSlotForAll = true ) {

    if ( !sameSlotForAll ) {
      throw new Error('Different slot per resource is for now not supported.');
    }

    for (let bsi of this.bookingSelectionItems ) {
      bsi.setInterval( interval );
    }

    this.start = interval.from;

    this.refreshDerivedData();

    if (this.bookingSelectionItems.length === 0 ){
      
       this.end = interval.to;
       this.selectedEnd = interval.to;

       let ms = moment(interval.from);
       let me = moment(interval.to);
       
       this.selectedDurationInSeconds = me.diff(ms, 'seconds');
    }

  }


  public setBookingProducts( bookingProducts ) {

    this.bookingProducts = bookingProducts;
    this.refreshDerivedData();

  }

  refreshDerivedData() {

    const todayMidnight = moment().startOf('day');

    this.newFromToday = ( moment(this.created) > todayMidnight && this.status < 30 && !this.enteredByAdmin );

    if ( this.newFromToday && localStorage.getItem( 'seen_' + this.id ) ) {
      this.newFromToday = false;
    }

    //keep the end when no table is picked ( invalid state ) 
    console.log(this.start);
    console.log(this.end);

    if ( this.bookingSelectionItems.length > 0 ) {
      this.end = null;
    }

    console.log('hi');

    if ( this.partySize && this.occasion /*&& !this.id*/ ) { //new event booking default

      console.log('ho');
      
      let price = 0.00;

      if ( this.occasion.regularPrice1  ) {
        price = this.occasion.regularPrice1; 

      } else if ( this.occasion.service && this.occasion.service.regularPrice1 ) {
        price = this.occasion.service.regularPrice1; 
      }

      this.paymentAmount = price * this.partySize;

      this.regularPaymentAmount = this.paymentAmount;

      if ( this.discountPercentage && this.discountPercentage > 0 && this.discountPercentage <= 100 ) {
        this.paymentAmount = (100 - this.discountPercentage) / 100 * this.paymentAmount;
      }

      if ( this.discountAmount && this.discountAmount > 0 && this.discountAmount <= this.paymentAmount ) {
        this.paymentAmount = this.paymentAmount - this.discountAmount;
      }

      console.log(this.paymentAmount);

    }

    //this.paymentAmount = this.partySize * 50.00;

    //this.amountPaidByBankTransfer = (Math.random() < 0.5) ? this.paymentAmount: 0.00;
    //this.amountPaidByBankTransfer  r = 30.00;

    //this.amountToBePaid = 10;

    this.total = null;

    for (let si of this.bookingSelectionItems ) {

       this.resourceIds.push(si.selectionItem.real.id);

       if ( !this.end || moment(si.end) < moment(this.end) ) {
         this.end = si.end;
       }

       let ms = moment(this.start);
       let me = moment(this.end);
       
       this.durationInSeconds = me.diff(ms, 'seconds');

       if (si.price) {

         if (!this.total) {
           this.total = new Price( si.price.amount, si.price.currency );
         } else {
           this.total.amount += si.price.amount;
         }

       }

     }

     for (let bp of this.bookingProducts ) {

       if (bp.price) {

         if (!this.total) {
           this.total = new Price( bp.price.amount * bp.quantity, bp.price.currency );
         } else {
           this.total.amount += bp.price.amount * bp.quantity;
         }

       }

     }



     //this.status = this.getBookingStatus();

     this.color = this.getBookingColor();
     this.statusStr = this.getStatusStr( this.status );

     this.calculateAmountToBePaid();

  }


  areEssentialsSet() {

    if ( !this.start || !this.end || !this.partySize ) {
      return false;
    }

    if ( !this.bookingSelectionItems || this.bookingSelectionItems.length === 0 ) {
      return false;
    }

    return true;

  }

  composeApiBody( loggedInUser: User) {

    try {

    console.log('aaa');

    let toApiDateFormat = function( string ) {
      return moment( string ).format('YYYY-MM-DDTHH:mm:ssZZ');
    }

   

    //set logged in user if customer is not picked
    if ( !this.user ) {
      this.user = loggedInUser;
    }

    let bookingSelectionItemsData = [];

    for (let bsi of this.bookingSelectionItems ) {

       bookingSelectionItemsData.push({
        'selectionItem': bsi.selectionItem._self,
        'start': toApiDateFormat( bsi.start ),
        'end': toApiDateFormat( bsi.end )
       });

    }

    let bookingProductsData = [];

    for (let bp of this.bookingProducts ) {

      /*             ->add('currency')
             ->add('price')
            ->add('vatRate', 'number')
            ->add('discountPercentage', 'number')
            ->add('customName')
            ->add('service', 'service_selector')*/

       bookingProductsData.push({
        'currency': 'EUR',
        'price': bp.price.amount,
        'service': bp.service._self,
        'quantity': bp.quantity
       });

    }

    let bookingAttendeesData = [];

    for ( let ba of this.bookingAttendees ) {

       bookingAttendeesData.push({
        'name': ba.name,
        'surname': ba.surname,
        'email': ba.email,
        'phone': ba.phone,
        'notifications': ba.notifications,
        'street': ba.street,
        'city': ba.city,
        'zipCode': ba.zipCode,
        'country': ba.country,
        'dateOfBirth': ba.dateOfBirth ? toApiDateFormat( ba.dateOfBirth ): null,
        'personalIdentNumber': ba.personalIdentNumber,
        'passportNumber': ba.passportNumber
       });

    }

    let body = {

      'start': toApiDateFormat( this.start ),
      'provider': this.provider._self,
      'mode': this.mode,
      'bookingSelectionItemsData': bookingSelectionItemsData,
      'bookingProductsData': bookingProductsData,
      'bookingAttendeesData': bookingAttendeesData,
      'enteredByAdmin': this.enteredByAdmin,
      'partySize': this.partySize,
      'editorNotes': this.editorNotes,
      'customerNotes': this.customerNotes,
      'emailNotes': this.emailNotes,

       //keep the current values
      'fjcEventId': this.fjcEventId,
      'fjcEventType': this.fjcEventType,
      'fjcEventName': this.fjcEventName,
      'fjcEventReference': this.fjcEventReference,
      'fjcContactPersonAtLocation': this.fjcContactPersonAtLocation,
      'fjcContactPersonPhone': this.fjcContactPersonPhone,
      'fjcContactPersonEmail': this.fjcContactPersonEmail,
      'fjcContactPersonCellPhone': this.fjcContactPersonCellPhone,
      'fjcInfoHtml': this.fjcInfoHtml,
      'fjcPartySizeNotes': this.fjcPartySizeNotes,
      'fjcExpectedPartySize': this.fjcExpectedPartySize,

      'site': environment.apiUrl + '/sites/' + environment.siteId

    }

    if ( this.occasion ) {

      body['occasion'] = this.occasion._self;

      body['registrationStatus'] = this.registrationStatus;

      if ( this.paymentAmount ) {

        body['paymentAmount'] = this.paymentAmount;
        body['paymentRequired'] = true;

        if ( this.discountAmount ) {
          body['discountAmount'] = this.discountAmount;
        }

        if ( this.discountPercentage) {
          body['discountPercentage'] = this.discountPercentage;
        }

        if ( this.regularPaymentAmount) {
          body['regularPaymentAmount'] = this.regularPaymentAmount;
        }

        console.log(this.paymentByBankTransfer);
        console.log(this.amountPaidByBankTransfer);

        body['paymentByBankTransfer'] = this.paymentByBankTransfer;
        
        body['paymentOnSite'] = this.paymentOnSite;

        body['amountPaidByBankTransfer'] = this.amountPaidByBankTransfer;

        body['paymentByVoucher'] = this.paymentByVoucher;
        
        body['voucherCode'] = this.voucherCode;
        body['voucherCode2'] = this.voucherCode2;
        body['voucherCode3'] = this.voucherCode3;
        body['voucherCode4'] = this.voucherCode4;
        body['voucherCode5'] = this.voucherCode5;
        body['voucherCode6'] = this.voucherCode6;
        body['otherVoucherCodes'] = this.otherVoucherCodes;

        body['amountPaidByVoucher'] = this.amountPaidByVoucher;

        body['paymentByCard'] = this.paymentByCard;
        body['amountPaidByCard'] = this.amountPaidByCard
      }

    }

    /*if ( loggedInUser.id === this.user.id || this.noUserSelected === true ) {
      body['noUserSelected'] = true;
    }*/


     return body;

    } catch (error) {
      console.error('🔥 composeApiBody failed:', error);
      throw error; // rethrow if needed
    }


  }

  getPickedTables() {

    let pickedTables = {};

    for (let bsi of this.bookingSelectionItems ) {

      pickedTables[bsi.selectionItem.real.id] = bsi.selectionItem.real.id;

    }

    return pickedTables;

  }

  getFirstRealId() {

    if ( undefined === this.bookingSelectionItems[0] ) {
      return;
    }

    return this.bookingSelectionItems[0].selectionItem.real.id
    

  }


  getLocationName() {

    if ( undefined === this.bookingSelectionItems[0] ) {
      return false;
    }

    if ( this.bookingSelectionItems[0].selectionItem && this.bookingSelectionItems[0].selectionItem.real && this.bookingSelectionItems[0].selectionItem.real.parent ) {

      if ( this.bookingSelectionItems[0].selectionItem.real.parent.parent) {
        return this.bookingSelectionItems[0].selectionItem.real.parent.parent.name;
      } else {
        return this.bookingSelectionItems[0].selectionItem.real.parent.name;
      }

    }


    return false;
    

  }

  composeCustomerDisplayName() {

    if ( this.noUserSelected || !this.user ) {
      return '';
    }

    if (this.user.email === 'brez.prijave@table42.app') {
      return this.onBehalfOfName || 'Brez registracije';
    }


    if (this.onBehalfOfName) {
      return this.onBehalfOfName || this.user.composeFullName();
    }

    if ( this.user.companyName ) {
      return this.user.companyName;
    } else {
      return this.user.composeFullName();
    }

  }

  composeShortDurationString() {

    if ( !this.durationInSeconds ) {
      return '';
    }

    let durationInMinutes = this.durationInSeconds / 60;

    let hours = Math.floor( durationInMinutes / 60 );

    if ( 30 === durationInMinutes % 60 ) {
       return hours + ',5h';
    }


    let minutes = durationInMinutes % 60;

    let result = '';

    if ( hours ) {
      result += hours + 'h';
    }

    if ( minutes ) {

      if ( hours ) {
        result += ' ';
      }

     
      result += Math.round( minutes ) + 'min';

    }


    return result;

  }

  getStatusStr( status ) {

    let statuses = {
      '-20': 'Ni prišel!',
      '-10': 'Odpovedana',
      '10': 'Ni še potrjena!',
      '20': 'Rezervirano',
      '30': 'Prišel',
      '40': 'Poseden',
      '50': 'Odšel',
    }

    if ( statuses[ status ] ) {
      return statuses[ status ];
    }

    return '';

  }

  getBookingStatus() {

    if ( this.canceled ) {

      return BookingStatus.Canceled;

      if ( this.noShow ) {
        return BookingStatus.NoShow;
      }

    }

    if ( this.arrived && !this.departed ) {
      return BookingStatus.Arrived;
    } 

    if ( this.departed ) {
      return BookingStatus.Departed;
    } 

    return BookingStatus.Reserved;

  }

  getBookingColor() {

    const history = 'gray';
    const future = '#000080';

    const futureShades = [];

    futureShades[1] = '#1a1aff';
    futureShades[2] = '#0000ff';
    futureShades[3] = '#0000e6';
    futureShades[4] = '#0000cc';
    futureShades[5] = '#0000b3';
    futureShades[6] = '#000099';


    const active = '#2dd36f';
    const warning = '#eb445a';
    const request = 'red';
    const noShow = 'black';

    if ( moment( this.end ) < moment() ) {
      return history;
    }

    if ( 10 === this.status ) {
      return request;
    }

    if ( this.arrived  && !this.departed ) {
      return active;
    }

    if ( this.noShow ) {
      return noShow;
    }

    if ( moment( this.start ) < moment() && moment( this.end ) < moment() ) {
      return warning;
    }

    if ( futureShades[this.partySize] ) {
      return futureShades[this.partySize];
    } else {
      return future;
    }

    

  }

  detectChangesCopy(){
    
    /*var copy = new Booking();


    copy.start = this.start;
    copy.editorNotes = this.editorNotes;
    copy.partySize = this.partySize;
    
    copy.user = this.user;
    copy.noUserSelected = this.noUserSelected;

    copy.bookingSelectionItems = this.bookingSelectionItems;
    copy.bookingProducts = this.bookingProducts;

    return copy;*/

  }


  getRootReal() {

    if ( this.occasion && this.occasion.location ) {
      return this.occasion.location;
    } 

    if ( this.bookingSelectionItems && 
      this.bookingSelectionItems[0] &&
      this.bookingSelectionItems[0].selectionItem  &&
      this.bookingSelectionItems[0].selectionItem.real  &&
      this.bookingSelectionItems[0].selectionItem.real.parent &&
      this.bookingSelectionItems[0].selectionItem.real.parent.parent 
    ) {
      return this.bookingSelectionItems[0].selectionItem.real.parent.parent;
    }

    return null;

  }



}